/* eslint-disable @typescript-eslint/naming-convention */ // strict PascalCase doesn't really make sense here
export var Breakpoint;
(function (Breakpoint) {
    Breakpoint["3XS"] = "3xs";
    Breakpoint["2XS"] = "2xs";
    Breakpoint["XS"] = "xs";
    Breakpoint["SM"] = "sm";
    Breakpoint["MD"] = "md";
    Breakpoint["LG"] = "lg";
    Breakpoint["XL"] = "xl";
})(Breakpoint || (Breakpoint = {}));
